import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";

export class AuthenticationService {
  public async login(jsonBody: any, dashboardUser: any) {

    try {
      let response = await fetch(`${BASE_URL}/users/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": window.location.host,
          dashboard: dashboardUser,
          app: "WEB",
        },
        body: JSON.stringify(jsonBody),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async retrieve(jsonBody: any) {
    try {
      let response = await fetch(`${BASE_URL}/users/reset/retrieve`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "origin": `http://${window.location.host}`,
          app: "WEB",
        },
        body: JSON.stringify(jsonBody),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async verify(jsonBody: any) {
    try {
      let response = await fetch(`${BASE_URL}/users/reset/verify`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "origin": `http://${window.location.host}`,
          app: "WEB",
        },
        body: JSON.stringify(jsonBody),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async reset(jsonBody: any) {
    try {
      let response = await fetch(`${BASE_URL}/users/reset`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "origin": `http://${window.location.host}`,
          app: "WEB",
        },
        body: JSON.stringify(jsonBody),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async getOne(user_id: String) {
    try {
      let response = await fetch(`${BASE_URL}/users/${user_id}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });

      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async refreshToken() {
    try {
      let response = await fetch(`${BASE_URL}/users/refresh`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });

      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async logout() {
    try {
      let response = await fetch(`${BASE_URL}/users/logout`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });

      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async register(formData: any) {
    let jsonBody = JSON.stringify(formData);
    try {
      let response = await fetch(`${BASE_URL}/users/register`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          app: "WEB",
        },
        body: jsonBody,
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async getUsersByCompanyId(companyId: String) {
    try {
      let response = await fetch(`${BASE_URL}/users/companies/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async getUsers() {
    try {
      let response = await fetch(`${BASE_URL}/users`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async addUser(formData: any) {
    let jsonBody = JSON.stringify(formData);
    let urlNormalUser = `${BASE_URL}/users/add`;
    let urlDashboardUser = `${BASE_URL}/users/dashboard`;
    try {
      let response = await fetch(
        formData.dashboard ? urlDashboardUser : urlNormalUser,
        {
          method: "POST",
          headers: AuthUtils.getHeaders(),
          body: jsonBody,
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async editUser(formData: any) {
    let jsonBody = JSON.stringify(formData);
    try {
      let response = await fetch(`${BASE_URL}/users/${formData._id}`, {
        method: "PUT",
        headers: AuthUtils.getHeaders(),
        body: jsonBody,
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async deleteUser(formData: any) {
    let jsonBody = JSON.stringify(formData);
    try {
      let response = await fetch(`${BASE_URL}/users/${formData._id}`, {
        method: "DELETE",
        headers: AuthUtils.getHeaders(),
        body: jsonBody,
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async deleteAllSelectedUsers(selectedList: any, companyId?: any) {
    let url = `${BASE_URL}/users/delete/multiple`;
    if (companyId) {
      url = url.concat(`/${companyId}`);
    }
    try {
      let response = await fetch(url, {
        method: "DELETE",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(selectedList),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      return {
        //@ts-ignore
error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
}
